<template>
  <div class="fill-height">
    <v-content class="fill-height">
      <v-container fluid>
        <Loader v-if="loading"/>
        <template v-else>
          <v-toolbar dense color="transparent" flat class="mb-3" style="z-index: 2">
            <v-toolbar-title>
              {{ name }}
            </v-toolbar-title>
          </v-toolbar>
          <div v-if="!count" class="red--text pa-4">
            В этом чате нет зарегистрированных сообщений
          </div>
          <template v-else>
            <div class="text-center mt-10 mb-10" v-if="more.status && list.length > 19">
              <v-btn color="primary" rounded outlined depressed :loading="more.loading" @click="loadMore">
                Показать предыдущие
              </v-btn>
            </div>
            <div v-for="(message, index) in list" :key="'comment_'+index">
              <v-card v-if="!message.hide" class="mb-6" rounded>
                <v-toolbar
                    flat
                    color="white"
                    rounded
                >
                  <v-avatar color="blue-grey lighten-4" size="40" class="mr-5">
                    <v-icon color="white">mdi-account</v-icon>
                  </v-avatar>
                  <v-toolbar-title>
                    <div class="subtitle-1 font-weight-bold mb-0">{{ message.name }}</div>
                    <div
                        class="blue-grey--text caption"
                    >
                      От {{ getDate(message.created) }}
                    </div>
                  </v-toolbar-title>
                </v-toolbar>
                <v-divider/>
                <v-container fluid style="white-space: pre-line;">
                  <div v-if="message.message.length" v-html="message.message"/>
                  <div v-if="message.attachment" class="d-flex justify-center align-center" style="cursor: pointer" @click="download(message.attachment.ID)">
                    <v-icon
                        small
                        color="amber"
                    >
                      mdi-file-document
                    </v-icon>
                    <v-card-text class="caption primary--text">
                      Вложение
                    </v-card-text>
                  </div>
                </v-container>
              </v-card>
            </div>
          </template>
        </template>
      </v-container>
    </v-content>
    <v-snackbar
        v-model="snack"
        bottom
        :timeout="-1"
    >
      Запрос доступа...
      <template v-slot:action="{ attrs }">
        <v-progress-circular
            indeterminate
            color="thunderbird"
            v-bind="attrs"
            size="20"
            width="3"
        ></v-progress-circular>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'ChatDetail',
  data: () => ({
    loading: true,
    list: [],
    name: "",
    offset: 0,
    count: 0,
    more: {
      loading: false,
      status: true
    },
    snack: false
  }),
  components: {
    Loader:    ()  => import('@/components/placeholder/Loader'),
  },
  methods: {
    download(id) {
      this.snack = true;
      this.$http.get(`${this.$serverApiLink}chats/download/${id}`).then(
          response => {
            window.location.href = response.data.data;
            this.snack = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.snack = false;
          }
      );
    },
    getChatMessages() {
      this.loading = true;
      this.$http.get(`${this.$serverApiLink}chats/messages/${this.$route.params.id}/0`).then(
          response => {
            this.list = response.data.data.reverse();
            this.count = response.data.count;
            this.name = response.data.name;
            this.offset = 20;
            this.loading = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.loading = false;
          }
      );
    },
    loadMore() {
      this.more.loading = true;
      this.$http.get(`${this.$serverApiLink}chats/messages/${this.$route.params.id}/${this.offset}`).then(
          response => {
            if (response.data.data.length > 0) {
              for (let i = 0; i < response.data.data.length; i++) {
                this.list.unshift(response.data.data[i]);
              }
            } else {
              this.more.status = false;
            }
            this.more.loading = false;
            this.offset += 20;
            this.more.loading = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.more.loading = false;
          }
      );
    },
    getDate(unix) {
      let date = new Date(unix * 1000);
      let hours = date.getHours();
      let minutes = "0" + date.getMinutes();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      let formattedTime = hours + ':' + minutes.substr(-2);
      let formattedDate = day + '-' + month + '-' + year;
      return formattedDate + ' ' + formattedTime;
    },
  },
  mounted() {
    this.getChatMessages();
  }
}
</script>